import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { FontAwesomeIcon } from 'atoms/icons';
import { Horizontal } from 'atoms/layout/flex';
import { glossary } from 'lib/glossary';
import { laptopAndAbove, mediumDesktopAndAbove } from 'style/mediaQuery';

import Button from '../Button';

const Wrapper = styled(Horizontal)`
  position: top;
  margin-bottom: var(--unit);
  @media ${laptopAndAbove} {
    padding: var(--unit);
    position: fixed;
  }
`;

const ButtonLabel = styled.p`
  display: none;
  @media ${mediumDesktopAndAbove} {
    display: block;
  }
`;

export const BackButton = () => {
  const navigate = useNavigate();

  const onGoBack = () => {
    return navigate(-1);
  };

  return (
    <Wrapper>
      <Button
        color="tertiary"
        size="medium"
        role="button"
        startIcon={<FontAwesomeIcon icon={faChevronLeft} />}
        onClick={onGoBack}
      >
        <ButtonLabel>
          <FormattedMessage {...glossary.back} />
        </ButtonLabel>
      </Button>
    </Wrapper>
  );
};

export default BackButton;
